import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Soft-deletes a Retained Net Income and frees its cutoffs
export const deleteRetainedNetIncome = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/retained_net_income/deleteRetainedNetIncome`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
